import { Box, Button, Stack } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAnswerSeV2QuestionMutation } from "../../../../autogen/bff-api";
import { richTextHasContent } from "../../../../common/components/communication/communicationUtils";
import { useApiError } from "../../../../common/errors/useApiError";
import { TipTap } from "../../../../common/input/TipTap/TipTap";

export const AnswerForm = ({ eventId, questionId }: { eventId: string; questionId: string }) => {
  const { t } = useTranslation();
  const displayer = useApiError();
  const [answer, setAnswer] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const [answerQuestion, { isLoading }] = useAnswerSeV2QuestionMutation();

  const handleSubmit = async () => {
    if (!richTextHasContent(answer)) return;
    try {
      await answerQuestion({ eventId, questionId, seV2QuestionPatchDto: { answer } }).unwrap();
      setAnswer("");
      setResetKey((key) => key + 1);
    } catch (error) {
      displayer.trigger(error);
    }
  };

  return (
    <Stack spacing="3" bg="smBackground" borderWidth="1px" borderColor="smBorder" rounded="md" p="3">
      <TipTap key={resetKey} content="" editable debounceWait={0} onUpdate={(value) => setAnswer(value)} />
      <Box textAlign="right">
        <Button
          size="sm"
          colorScheme="teal"
          onClick={handleSubmit}
          isLoading={isLoading}
          isDisabled={!richTextHasContent(answer)}
        >
          {t("Send private answer")}
        </Button>
      </Box>
    </Stack>
  );
};
